import React from 'react'
import { Box } from '@mui/material'
import { ServicesHero, ServicesServices, ServicesWhatWeDo, ContactInfo } from '../containers'
import { Footer, Hero } from '../components'

const Services = () => {

  return (
    <Box>
        <Hero />
        <ServicesWhatWeDo />
        <ServicesServices />
        <Footer />
    </Box>
  )
}

export default Services